import React from "react";

const LoyaltyContext = React.createContext();

export const LoyaltyProvider = LoyaltyContext.Provider;
export const LoyaltyConsumer = LoyaltyContext.Consumer;

export default LoyaltyContext;
